import { useState, useEffect, memo } from "react";
import "../assets/css/footer.css";
import {
  FaSquareFacebook,
  FaSquareInstagram,
  FaSquareXTwitter,
  FaPhone,
  FaMapLocationDot,
} from "react-icons/fa6";
import { AiFillTikTok } from "react-icons/ai";
import { Loading } from "../components/loading";
import { MdEmail, MdAccessTimeFilled } from "react-icons/md";
import { PopupDialog } from "../components/popupDialog";

export const Footer = memo(({ general, contactUs, socialMedia }) => {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const initialValue = {
    title: "",
    richTextValue: "",
  };
  const [selectedRichTextValue, setSelectedRichTextValue] =
    useState(initialValue);
  const socialMediasConst = [
    {
      title: "facebook",
      icon: <FaSquareFacebook className="white-social-media-icon" />,
    },
    {
      title: "tiktok",
      icon: <AiFillTikTok className="white-social-media-icon" />,
    },
    {
      title: "instagram",
      icon: <FaSquareInstagram className="white-social-media-icon" />,
    },
    {
      title: "x",
      icon: <FaSquareXTwitter className="white-social-media-icon" />,
    },
  ];
  const handlePopup = (title, richTextValue) => {
    setSelectedRichTextValue({
      title: title,
      richTextValue: richTextValue,
    });
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedRichTextValue(initialValue);
  };
  useEffect(() => {
    if (general && contactUs?.length > 0 && socialMedia?.length > 0) {
      setLoading(false);
    }
  }, [general, contactUs, socialMedia]);

  return (
    <section id="footer">
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div className="details-container">
            <div className="cafe-details">
              <div>
                <FaPhone className="white-icon " />
                {general.cafeContactNum}
              </div>
              <div>
                <MdEmail className="white-icon " />
                {general.cafeEmail}
              </div>
              <div>
                <FaMapLocationDot className="white-icon " />
                {general.cafeAddress}
              </div>
              <div>
                <MdAccessTimeFilled className="white-icon " />
                {general.operationStartTime} - {general.operationEndTime}
              </div>
            </div>
            <div className="web-details">
              <div className="column-container">
                <div className="row-container">
                  {socialMedia?.map((socialMedia, index) => {
                    const sm = socialMediasConst.find(
                      (media) => media.title === socialMedia?.type
                    );
                    return (
                      <div key={index}>
                        <a
                          href={socialMedia.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="footer-icon"
                        >
                          {sm.icon}
                        </a>
                      </div>
                    );
                  })}
                </div>
                <div
                  className="underline"
                  onClick={() =>
                    handlePopup("Privacy Policy", general.privacyPolicy)
                  }
                >
                  PRIVACY POLICY
                </div>
                <div
                  className="underline"
                  onClick={() =>
                    handlePopup(
                      "Terms & Conditions",
                      general.termsAndConditions
                    )
                  }
                >
                  TERMS & CONDITIONS
                </div>
              </div>
            </div>
          </div>
          <div className="details-container label-container">
            <div>{general.copyrightLabel}</div>
            <div>{general.poweredByLabel}</div>
          </div>
        </div>
      )}
      <PopupDialog
        name="richTextPopup"
        open={open}
        onClose={handleClose}
        title={selectedRichTextValue.title}
        content={
          <div className="rich-text-preview-div">
            <div
              className="rich-text-preview-inner-div"
              dangerouslySetInnerHTML={{
                __html: selectedRichTextValue.richTextValue,
              }}
            />
          </div>
        }
      />
    </section>
  );
});
